<template>
  <div class="salesman-form" v-loading="loading">
    <div class="btn">
      <Button class="save-btn" type="primary" @click="save()"
        v-if="['base', 'jobNumber', 'material'].includes(tabId)">保存</Button>
      <Button class="save-btn" :class="{ 'save-btn2': ['base', 'jobNumber', 'material'].includes(tabId) }" ghost type="primary"
        @click="back($route.query.route)">返回</Button>
    </div>
    <Tabs v-model="tabId" :animated="false" @on-click="tabChange">
      <TabPane v-for="(bean) in tabList" :key="bean.id" :label="bean.name" :name="bean.id">
        <component :is="bean.form" ref="form" @save="reload"></component>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import baseForm from './components/base'
import jobNumberForm from './components/jobNumber'
import contractForm from './components/contract'
import materialForm from './components/material'
import recordForm from './components/record'
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  components: {
    baseForm,
    jobNumberForm,
    contractForm,
    materialForm,
    recordForm,
  },
  data() {
    return {
      loading: false,
      tabId: "base",
      tabList: [
        { id: "base", name: "基础信息", form: "baseForm" },
        { id: "jobNumber", name: "上游工号", form: "jobNumberForm" },
        { id: "contract", name: "合同管理", form: "contractForm" },
        { id: "material", name: "资料管理", form: "materialForm" },
        { id: "record", name: "变更记录", form: "recordForm" },
      ],
      groupId: "",//团队id
      organizationId:'',//机构id
      indoorStaffId: "",//业务员id
      groupData: {},//当前组织数据
      saveList: ["base"],
      nodeType:''
    };
  },
  activated() {
    console.log('activated',this.$route.query,sessionStorage.reloadData)
    if (sessionStorage.reloadData == '1') {
      sessionStorage.reloadData = '';
      this.tabId = "base";
      this.$refs.form[0].setData()
    }
  },
  async mounted() {
    this.groupId = this.$route.query.groupId;
    this.indoorStaffId = this.$route.query.indoorStaffId;
    this.organizationId = this.$route.query.organizationId;
    console.log(this.organizationId,this.groupId);
    sessionStorage.reloadData = '';
    this.tabChange();
  },
  methods: {
    reload(data) {
      console.log("form.reload")
      this.indoorStaffId = data.id;
      this.groupId = data.groupId;
      this.organizationId = data.organizationId;
      const fullPath = this.$route.fullPath;
      let query
      if(this.groupId){
        query= {
          groupId: this.groupId,
          organizationId: this.organizationId,
          indoorStaffId: this.indoorStaffId,
          route:this.$route.query.route
        }
      }else{
        query= {
          organizationId: this.organizationId,
          indoorStaffId: this.indoorStaffId,
          route:this.$route.query.route
        }
      }
      this.$router.push({
        path: "/systemSet/houseStaffForm/" + this.indoorStaffId,
        query: query
      })
      window.setTimeout(() => {
        window.parent.postMessage({
          removePageTag: fullPath,
          appMessage: true,
        }, "*");
      }, 100)
    },
    tabChange() {
      if (!this.indoorStaffId && this.tabId != "base") {
        this.$nextTick(() => {
          this.tabId = "base";
        })
        this.$notice.msg("数据尚未保存")
        return;
      }
      if (!this.saveList.includes(this.tabId)) {
        this.saveList.push(this.tabId)
      }
      const map = {
        "base": 0,
        "jobNumber": 1,
        "contract": 2,
        "material": 3,
        "record": 4,
      }
      // window.setTimeout(()=>{
      //   console.log(this.userId,this.$refs.form)
      //   this.$refs.form[map[this.tabId]].setData()
      // },300)
      this.$nextTick(() => {
        this.$refs.form[map[this.tabId]].setData()
      })
    },
    async save() {
      try {
        if (this.loading) {
          return;
        }
        this.loading = true;
        const map = {
          "base": 0,
          "jobNumber": 1,
          "material": 3,
        }
        for (let i = 0; i < this.saveList.length; i++) {
          if (map.hasOwnProperty(this.saveList[i])) {
            await this.$refs.form[map[this.saveList[i]]].save();
          }
        }
        this.$notice.success("保存成功");
        this.loading = false;
      } catch (e) {
        this.loading = false;
        if (e.showMsg) {
          this.$notice.msg("请完善信息")
        }
        if (e.page) {
          this.tabId = e.page
        }
      }
    },
    
  },
};
</script>
<style lang="scss" scoped>@import './houseStaffForm.scss';</style>